import { render, staticRenderFns } from "./Logbook.vue?vue&type=template&id=e96de416&scoped=true&"
import script from "./Logbook.vue?vue&type=script&lang=js&"
export * from "./Logbook.vue?vue&type=script&lang=js&"
import style0 from "./Logbook.vue?vue&type=style&index=0&id=e96de416&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96de416",
  null
  
)

export default component.exports